import {ModalContainerTelegram} from "../Modal/ModalContainerTelegram";

export var DepartureFlightInfoBlock = {
    controller: function (args) {
        this.data = args.data;
        this.info_obr = args.info_obr;
        this.showBookingBlock = args.showBookingBlock;
        this.infoTurnaroundFlight = args.infoTurnaroundFlight;
        this.infoFlightTimeTransPax = args.infoFlightTimeTransPax;
    },
    view: function (ctrl) {
        return m(".container[style='padding-top:10px'][id='containerInfo']", [
            ctrl.info_obr != "" && ctrl.infoTurnaroundFlight ?
                m("p.text-center[style='margin-top: 5px;'][id='titleBlock']", "Информация по рейсу вылета:") : [],
            m(".row", [
                m(".col-xs-6[style='padding:0 5px 0 10px']", [
                    m("span", "Номер рейса"),
                    m("p.text-center.bg-danger[id='NR']", ctrl.data.NR || m.trust("&nbsp;"))
                ]),
                m(".col-xs-6[style='padding:0 10px 0 5px']", [
                    m("span", "Тип ВС"),
                    m("p.text-center.bg-danger[id='TS_ICAO']", ctrl.data.TS_ICAO || m.trust("&nbsp;"))
                ])
            ]),
            m(".row", [
                m(".col-xs-6[style='padding:0 5px 0 10px']", [
                    m("span", "Бортовой номер"),
                    m("p.text-center.bg-danger[id='BORT']", ctrl.data.BORT || m.trust("&nbsp;"))
                ]),
                m(".col-xs-6[style='padding:0 10px 0 5px']", [
                    m("span", "МС"),
                    m("p.text-center.bg-danger[id='NST']", ctrl.data.NST || m.trust("&nbsp;"))
                ])
            ]),
            m(".row", [
                m(".col-xs-12[style='padding:0 10px']", [
                    m("span", "Маршрут"),
                    m("p.text-center.bg-danger[id='route']", ctrl.data.route + (ctrl.data.planDate ? " [" + ctrl.data.planDate + "]" : ""))
                ])
            ]),
            m(".row", [
                m(".col-xs-4[style='padding:0 5px 0 10px']", [
                    m("span", "План"),
                    m("p.text-center.bg-danger[id='planTime']", ctrl.data.planTime || m.trust("&nbsp;"))
                ]),
                m(".col-xs-4[style='padding:0 5px']", [
                    m("span", "Отправление"),
                    m("p.text-center.bg-danger[id='DTFM']", ctrl.data.DTFM || m.trust("&nbsp;"))
                ]),
                m(".col-xs-4[style='padding:0 10px 0 5px']", [
                    m("span", "Взлет"),
                    m("p.text-center.bg-danger[id='DTVPM']", ctrl.data.DTVPM || m.trust("&nbsp;"))
                ])
            ]),

            m(".row", [
                m(".col-xs-12.text-center[style='padding:7px']", [
                    m("strong[style='font-size:16px']", "Задержка рейса")
                ])
            ]),

            m(".row", [
                m(".col-xs-6[style='padding:0 5px 0 10px']", [
                    m("span", "Код"),
                    m("p.text-center.bg-danger[id='PRICHF']", ctrl.data.PRICHF || m.trust("&nbsp;"))
                ]),
                m(".col-xs-6[style='padding:0 10px 0 5px']", [
                    m("span", "Время"),
                    m("p.text-center.bg-danger[id='DZADF']", ctrl.data.DZADF || 0)
                ])
            ]),

            m("div[id='TitleF']", [
                (ctrl.data.TitleF ?
                    m(".row", [
                        m(".col-xs-12[style='padding:0 10px']", [
                            m(".alert.alert-warning", [
                                m("i.fa.fa-info-circle"),
                                m("span", " " + ctrl.data.TitleF)
                            ])
                        ])
                    ]) : ''
                )
            ]),
            m(".row", [
                m(".col-xs-4[style='padding:0 5px 0 10px']", [
                    m("span", "Экипаж"),
                    m("p.text-center.bg-danger[id='KCE']", ctrl.data.KCE || 0)
                ]),
                m(".col-xs-4[style='padding:0 5px']", [
                    m("span", "Бортпроводники"),
                    m("p.text-center.bg-danger[id='KBP']", ctrl.data.KBP || 0)
                ]),
                m(".col-xs-4[style='padding:0 10px 0 5px']", [
                    m("span", "Техники"),
                    m("p.text-center.bg-danger[id='TECHNICS']", ctrl.data.TECHNICS || 0)
                ])
            ]),
            m(".row", [
                m(".col-xs-12.text-center[style='padding:7px']", [
                    m("strong[style='font-size:16px']", "Коммерческая загрузка F/C/W/Y")
                ])
            ]),
            m(".row", [
                m(".col-xs-12[style='padding:0 10px']", [
                    m("span", "Всего"),
                    m("p.text-center.bg-danger[id='KPASF']", ctrl.data.KPASF + '/' + ctrl.data.KPASC + '/' + ctrl.data.KPASW + '/' + ctrl.data.KPASY)
                ])
            ]),
            m(".row", [
                m(".col-xs-4[style='padding:0 10px 0 5px']", [
                    m("span", "ВЗР"),
                    m("p.text-center.bg-danger[id='KVZRF']", ctrl.data.KVZRF + '/' + ctrl.data.KVZRC + '/' + ctrl.data.KVZRW + '/' + ctrl.data.KVZRY)
                ]),
                m(".col-xs-4[style='padding:0 5px']", [
                    m("span", "РБ"),
                    m("p.text-center.bg-danger[id='KRBF']", ctrl.data.KRBF + '/' + ctrl.data.KRBC + '/' + ctrl.data.KRBW + '/' + ctrl.data.KRBY)
                ]),
                m(".col-xs-4[style='padding:0 10px 0 5px']", [
                    m("span", "РМ"),
                    m("p.text-center.bg-danger[id='KRMF']", ctrl.data.KRMF + '/' + ctrl.data.KRMC + '/' + ctrl.data.KRMW + '/' + ctrl.data.KRMY)
                ])
            ]),
            m(".row", [
                m(".col-xs-3[style='padding:0 5px 0 10px']", [
                    m("span", "Груз"),
                    m("p.text-center.bg-danger[id='GRUZ']", ctrl.data.GRUZ)
                ]),
                m(".col-xs-3[style='padding:0 5px']", [
                    m("span", "Почта"),
                    m("p.text-center.bg-danger[id='POCHTA']", ctrl.data.POCHTA)
                ]),
                m(".col-xs-6[style='padding:0 10px 0 5px']", [
                    m("span", "Багаж (кол. [кг.])"),
                    m("p.text-center.bg-danger[id='KBAGC']", ctrl.data.KBAGC + '/' + ctrl.data.KBAGY + ' [' + ctrl.data.VBC + '/' + ctrl.data.VBY + ']')
                ])
            ]),
            m(".row", [
                m(".col-xs-12.text-center[style='padding:7px']", [
                    m("strong[style='font-size:16px']", "Примечание")
                ])
            ]),
            m(".row", [
                m(".col-xs-12[style='padding:0 10px 0 10px']", [
                    m("p.text-center.bg-danger[id='PRIM']", ctrl.data.PRIM || ' ')
                ])
            ]),
            m("div[id='KZAF']", [
                ctrl.data.KZAF.map(function(field) {
                    return m(".row", [
                        m(".col-xs-6[style='padding:0 5px 0 10px']", [
                            m("p.text-center.bg-danger", field.title)
                        ]),
                        m(".col-xs-6[style='padding:0 10px 0 5px']", [
                            m("p.text-center.bg-danger", field.value)
                        ])
                    ])
                })
            ]),
            m(".row", [
                m(".col-xs-12.text-center[style='padding:7px']", [
                    m("strong[style='font-size:16px']", "Предупреждения")
                ])
            ]),
            m("div[id='alertInfo']", [
                ctrl.data.alerts.length > 0 ?
                    ctrl.data.alerts.map(function(alert) {
                        return m(".row", [
                            m(".col-xs-3[style='padding:0 5px 0 10px']", [
                                m("p.bg-warning.progress-bar-striped.text-center", alert.code)
                            ]),
                            m(".col-xs-7[style='padding:0 5px']", [
                                m("p.bg-warning.progress-bar-striped.text-center", alert.desc)
                            ]),
                            m(".col-xs-2[style='padding:0 10px 0 5px']", [
                                m("p.bg-warning.progress-bar-striped.text-center", alert.amount)
                            ])
                        ])
                    }):
                    m(".row", [
                        m(".col-xs-12[style='padding:0 10px 0 10px']", [
                            m("p.text-center.bg-danger", ' ')
                        ])
                    ])
            ]),
            m(".row", [
                m(".col-xs-12.text-center[style='padding:7px']", [
                    m("strong[style='font-size:16px']",
                        m.trust("Данные по отсекам")
                    )
                ])
            ]),
            m(".row", [
                m(".col-xs-12[style='padding:0 5px 0 10px']", [
                    m("span", "№: кол./кг. [признак]")
                ])
            ]),
            m("div[id='DL']", [
                ctrl.data.DL.length > 0 ?
                    ctrl.data.DL.map(function(info) {
                        return m(".row", [
                            m(".col-xs-12[style='padding:0 10px']", [
                                m("p.text-center.bg-danger", info.Comp + ': ' + (info.containers || '-') + ' / ' + (info.Weight || '-') + (info.type ? ' [' + info.type + ']' : ''))
                            ])
                        ])
                    }):
                    m(".row", [
                        m(".col-xs-12[style='padding:0 10px 0 10px']", [
                            m("p.text-center.bg-danger", ' ')
                        ])
                    ]),
            ]),
            m(".row", [
                m(".col-xs-12.text-center[style='padding:7px']", [
                    m("strong[style='font-size:16px']", "Трансферные пассажиры")
                ])
            ]),
            m(".row", [
                m(".col-xs-7[style='padding:0 5px 0 10px']", [
                    //m("span", "Дата / Рейс / АП")
                    m("span", "Дата / Время / Рейс / АП")
                ]),
                m(".col-xs-5[style='padding:0 10px']", [
                    m("span", "Пасс. / Багаж (кол./кг.)")
                ])
            ]),
            m("div[id='transfer']", [
                ctrl.data.transfer.length > 0 ?
                    ctrl.data.transfer.map(function (tran) {
                        return m(".row", [
                            m(".col-xs-7[style='padding:0 5px 0 10px']", [
                                ctrl.infoFlightTimeTransPax ? [
                                    tran.tr_dzad ?
                                        m("p.text-center.bg-danger[style='padding: 7px 10px;color: #ff0000;']", tran.tr_date + '/' + tran.tr_time + '/' + tran.tr_nr + '/' + tran.tr_ap ) :
                                        m("p.text-center.bg-danger[style='padding: 7px 10px;']", tran.tr_date + '/' + tran.tr_time + '/' + tran.tr_nr + '/' + tran.tr_ap )
                                ] : [
                                    m("p.text-center.bg-danger", tran.tr_date + '/' + tran.tr_time + '/' + tran.tr_nr + '/' + tran.tr_ap )
                                ]
                            ]),
                            m(".col-xs-5[style='padding:0 10px']", [
                                m("p.text-center.bg-danger", (tran.tr_kpax || '-') + ' / ' + (tran.tr_kbag || '-') + ' / ' + (tran.tr_vbag || '-'))
                            ])
                        ])
                    }) :
                    m(".row", [
                        m(".col-xs-12[style='padding:0 10px 0 10px']", [
                            m("p.text-center.bg-danger", ' ')
                        ])
                    ]),
            ]),
            ctrl.showBookingBlock && ctrl.data.booking ?
                [
                    m(".row", [
                        m(".col-xs-12.text-center[style='padding:7px']", [
                            m("strong[style='font-size:16px']", "Бронирование")
                        ])
                    ]),
                    m(".row", [
                        m(".col-xs-3[style='padding:0 5px 0 10px']", [
                            m("span", "Взрослые"),
                            m("p.text-center.bg-danger[id='BVZR']", ctrl.data.booking.BVZR || m.trust("&nbsp;"))
                        ]),
                        m(".col-xs-3[style='padding:0 5px']", [
                            m("span", "РБ"),
                            m("p.text-center.bg-danger[id='BRB']", ctrl.data.booking.BRB || m.trust("&nbsp;"))
                        ]),
                        m(".col-xs-3[style='padding:0 5px']", [
                            m("span", "РМ"),
                            m("p.text-center.bg-danger[id='BRM']", ctrl.data.booking.BRM || m.trust("&nbsp;"))
                        ]),
                        m(".col-xs-3[style='padding:0 10px 0 5px']", [
                            m("span", "Трансфер"),
                            m("p.text-center.bg-danger[id='transf']", (ctrl.data.booking.transf_in || "-") +
                                '/' + (ctrl.data.booking.transf_out || "-") )
                        ])
                    ]),
                    m(".row", [
                        m(".col-xs-4[style='padding:0 5px 0 10px']", [
                            m("span", "Багаж (кол./кг.)"),
                            m("p.text-center.bg-danger[id='BBAG']", String(ctrl.data.booking.BBAGPLC || "-") + '/' +
                                String(ctrl.data.booking.BBAG || "-"))
                        ]),
                        m(".col-xs-5[style='padding:0 5px']", [
                            m("span", "Груз (кол./кг./м.куб.)"),
                            m("p.text-center.bg-danger[id='BGRUZ']", String(ctrl.data.booking.BGRUZPLC || "-") + '/' +
                                String(ctrl.data.booking.BGRUZ || "-") + '/' + String(ctrl.data.booking.BGRUZVLM || "-"))
                        ]),
                        m(".col-xs-3[style='padding:0 10px 0 5px']", [
                            m("span", "Почта (кг.)"),
                            m("p.text-center.bg-danger[id='BPOCHTA']", ctrl.data.booking.BPOCHTA || m.trust("&nbsp;"))
                        ])
                    ]),
                    m(".row", [
                        m(".col-xs-12[style='padding:0 10px']", [
                            m("span", "SSR запросы"),
                            m("p.text-center.bg-danger[id='ssr']", ctrl.data.booking.ssr || m.trust("&nbsp;"))
                        ])
                    ]),
                    m(".row", [
                        m(".col-xs-12[style='padding:0 10px']", [
                            m("span", "Опасный груз"),
                            m("p.text-center.bg-danger[id='danger_cargo']", ctrl.data.booking.danger_cargo || m.trust("&nbsp;"))
                        ])
                    ]),
                    m(".row", [
                        m(".col-xs-12[style='padding:0 10px']", [
                            m("span", "Специальный груз"),
                            m("p.text-center.bg-danger[id='special_cargo']", ctrl.data.booking.special_cargo || m.trust("&nbsp;"))
                        ])
                    ])
                ] : '',
            m(".row", [
                m(".col-xs-12.text-center[style='padding:7px']", [
                    m("strong[style='font-size:16px']", "Телеграммы")
                ])
            ]),
            m(".row", [
                m(".col-xs-12[style='padding:0 5px 0 10px']", [
                    m("span", "Тип / Дата / Время"),
                        m("div[id='telegram']", [
                            ctrl.data.TEL.map(function(field) {
                                return m(".row", [
                                    m(".col-xs-12[style='margin:5px 0']", [
                                        m("button.btn.btn-danger.btn-block.btn-lg[type='submit']", {
                                            onclick: function () {
                                                ModalContainerTelegram.open(field.TEXT);
                                            }
                                        }, field.ID_TEL + " " + field.DTime)
                                    ])
                                ])
                            })
                        ]),
                ]),
            ])
        ])
    }
};
